import { render, staticRenderFns } from "./CreateExpenseItem.vue?vue&type=template&id=85a98d64"
import script from "./CreateExpenseItem.vue?vue&type=script&lang=js"
export * from "./CreateExpenseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85a98d64')) {
      api.createRecord('85a98d64', component.options)
    } else {
      api.reload('85a98d64', component.options)
    }
    module.hot.accept("./CreateExpenseItem.vue?vue&type=template&id=85a98d64", function () {
      api.rerender('85a98d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/expenses/CreateExpenseItem.vue"
export default component.exports